module.exports = __webpack_public_path__ + "img/drop.3de971bd.png";